// Phase 13.7 Step 1 — shared layout wrapper for authenticated pages.
// The sidebar stays dark navy; only the right-side main content flips to
// the light surface. Public marketing pages do NOT use this wrapper.
//
// Usage:
//   <DashboardLayout>           {/* defaults to surface="light"  */}
//   <DashboardLayout surface="dark">  {/* keep brand-dark page    */}
//
// Step 1 ships only Dashboard.jsx on the light surface; remaining authed
// pages are migrated in subsequent batches (Step 2).
import React from "react";
import Sidebar from "./Sidebar";

export default function DashboardLayout({ children, surface = "light", sidebar: SidebarOverride, testid }) {
  const Side = SidebarOverride || Sidebar;
  const mainCls =
    surface === "light"
      ? "flex-1 min-w-0 bg-[#F8F9FB] text-gray-900"
      : "flex-1 min-w-0 bg-fc-navy text-white";
  return (
    <div className="min-h-screen bg-fc-navy text-white flex" data-testid={testid || "dashboard-layout"} data-surface={surface}>
      <Side />
      <main className={mainCls} data-testid="dashboard-main">
        {children}
      </main>
    </div>
  );
}
